import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { UserCertificateDTO } from "../../schema/UserCourse/userCertificate/UserCertificateDTO";
import { UserCertificateQueryParamsDTO } from "../../schema/UserCourse/userCertificate/UserCertificateQueryParamsDTO";

@Injectable({
    providedIn: "root"
})
export class ApiUserCertificatesService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.userCourses.url}/api/v1/user/certificates`;
    }

    list(query: UserCertificateQueryParamsDTO): Observable<GetDataDTO<UserCertificateDTO>> {
        let param = new HttpParams()
            .set("skip", query.skip.toString())
            .set("take", query.take.toString())
            .set("subscriptionId", query.subscriptionId);

        if (query.id) param = param.set("id", query.id);
        if (query.userId) param = param.set("userId", query.userId);
        if (query.courseId) param = param.set("courseId", query.courseId);
        if (query.eventId) param = param.set("eventId", query.eventId);
        if (query.courseSubscriptionId) param = param.set("courseSubscriptionId", query.courseSubscriptionId);
        if (query.fillCourse) param = param.set("fillCourse", query.fillCourse.toString());

        return this.httpClient.get<GetDataDTO<UserCertificateDTO>>(this.relativePath, { params: param });
    }

    publicCertificateImage(id: string): Observable<string> {
        return this.httpClient.get(`${this.relativePath}/${id}/public-image`, { responseType: "text" });
    }
}
